module.exports = __webpack_public_path__ + "static/media/index-shop-7.8214e309.webp";